export default "__VITE_ASSET__DDvII4Bd__"